import React, { useMemo, useState } from 'react';

export function LoginScreen({ onLogin, loading, error }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [localError, setLocalError] = useState('');

  const canSubmit = useMemo(() => email.trim().length > 3 && password.length > 0 && !loading, [email, password, loading]);

  async function submit(event) {
    event.preventDefault();
    setLocalError('');

    if (!email.trim()) {
      setLocalError('Please enter your email.');
      return;
    }

    if (!password) {
      setLocalError('Please enter your password.');
      return;
    }

    try {
      await onLogin(email.trim(), password);
    } catch (_) {
      // Hook already sets error state
    }
  }

  return React.createElement(
    'main',
    { className: 'login-screen' },
    React.createElement(
      'section',
      { className: 'login-ascii' },
      React.createElement(
        'pre',
        { className: 'ascii-logo' },
        [
          '  ____ ___ ____ __  __ _   _ _   _ ____  ',
          ' / ___|_ _/ ___|  \\/  | | | | \\ | |  _ \\ ',
          ' \\___ \\| | |  _| |\\/| | | | |  \\| | | | |',
          '  ___) | | |_| | |  | | |_| | |\\  | |_| |',
          ' |____/___\\____|_|  |_|\\___/|_| \\_|____/'
        ].join('\n')
      ),
      React.createElement(
        'form',
        { className: 'login-form login-form-ascii', onSubmit: submit },
        React.createElement(
          'label',
          { className: 'login-label' },
          '[ email ]',
          React.createElement('input', {
            className: 'login-input',
            type: 'email',
            value: email,
            onChange: (e) => setEmail(e.target.value),
            placeholder: 'name@company.com',
            autoComplete: 'email'
          })
        ),
        React.createElement(
          'label',
          { className: 'login-label' },
          '[ password ]',
          React.createElement('input', {
            className: 'login-input',
            type: 'password',
            value: password,
            onChange: (e) => setPassword(e.target.value),
            placeholder: '********',
            autoComplete: 'current-password'
          })
        ),
        localError || error
          ? React.createElement('p', { className: 'login-error' }, localError || error)
          : null,
        React.createElement(
          'button',
          { className: 'login-submit', type: 'submit', disabled: !canSubmit },
          loading ? 'Signing in...' : 'Log In'
        )
      )
    )
  );
}
